import React from 'react';
import HeroesFormAccordion from './HeroesFormAccordion';
const HerosDiscountFormAccordionGroup = (props: any) => {
  return (
    <div className="HeroFormAccordionGroup-background">
      <div className="container mainContainer">
        <HeroesFormAccordion data={props.data} history={props.history} response={props.response}/>
      </div>
    </div>
  );
};

export default HerosDiscountFormAccordionGroup;